module.exports = __webpack_public_path__ + "img/line.0c7e7323.svg";